import { Steps } from "antd";
import { formatDateFunction } from "../../../../../utils/helper/utils";
import checkIcon from "../../../../../images/check-icon.svg";
import cancelIcon from "../../../../../images/cancel-icon.svg";
import whatsappIcon from "../../../../../images/whatsapp-icon.svg";
const TrackingHistory = ({ orderStatusLogs, whatsappNotificationLogs }) => {
  let items = [];

  if (orderStatusLogs)
    for (let item of orderStatusLogs) {
      if (item.status === "placed") {
        items.push({
          title: "Order Created",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order is created by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
            </div>
          ),
        });
      }
      if (item.status === "send_to_customer") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "editOrderNotification" || row.type === "approvalNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: "Order Send to Customer",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order request sent to customer for approval by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "reject") {
        items.push({
          title: (
            <div>
              <span className="text-red-700">Order Rejected</span>
            </div>
          ),
          description: (
            <div className="flex flex-col">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order is rejected by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              <div className="mt-3">{item.reason}</div>
            </div>
          ),
        });
      }
      if (item.status === "request_sent_to_recipient") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "giftRecipientNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: "Order Request sent to recipient",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order request sent to recipient by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "confirmed") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "orderConfirmedNotification" || row.type === "acceptOrderNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: "Order Accepted",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order has been accepted by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "processing") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "processingNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: "Order Preparing",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order status has been updated to Preparing by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "qc_accept") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "qcApprovedNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: "Order Accept By Qc",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order status has been accpted by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "qc_reject") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "qcApprovedNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: (
            <div>
              <span className="text-red-700">Order Rejected By Qc</span>
            </div>
          ),
          description: (
            <div className="flex flex-col">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order status has been rejected by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              <div className="mt-3">{item.reason}</div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "under_qa") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "underqaNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: "Order In-Review",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order status has been updated to In Review by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "ready_to_pick") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "qcApprovedNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: "Order Ready to ship",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order status has been updated by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "out_for_delivery") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "shippedNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: "Order Shipped",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order status has been updated by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "pickup_delivered") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "pickupDeliveredNotification" || row.type === "receipentAcceptNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: "Order Ready To Pickup For Customer",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order status has been updated by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "delivered") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "deliveredNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: "Order Completed",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order status has been updated by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "no_show") {
        items.push({
          title: "Order No Show",
          description: (
            <div className="flex flex-col">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order status has been updated by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
               </div>
              <div className="mt-3">{item.reason}{item.desc ? ` - ${item.desc}` : ""}</div>
            </div>
          ),
        });
      }
      if (item.status === "cancelled" || item.status === "cancle") {
        items.push({
          title: "Order Cancelled",
          description: (
            <div className="flex flex-col">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order is cancelled by {item?.addedBy?.userType ? item?.addedBy?.userType : null}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              <div className="mt-3">{item.reason}</div>
            </div>
          ),
        });
      }
      if (item.status === "placed" && item.reason === "Order reactivated from cancelled status") {
        items.push({
            description: "Awaiting for send to customer.",
          });
      }

      if (item.status === "refund") {
        items.push({
          title: "Refund Amount",
          description: (
            <div className="flex flex-col">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order is refund by {item?.addedBy?.userType ? item?.addedBy?.userType : null}
                  <strong> {item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              <div className="mt-3">{item.reason}</div>
            </div>
          ),
        });
      }
      if (item.status === "rescheduled") {
        items.push({
          title: "Rescheduled",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order is rescheduled by {item?.addedBy?.userType ? item?.addedBy?.userType : null}
                  <strong> {item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
            </div>
          ),
        });
      }
      if (item.status === "send_gift_receipent") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "giftMakePaymentNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: "Send gift receipent",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Gift is sent by {item?.addedBy?.userType ? item?.addedBy?.userType : null}
                  <strong> {item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "accpet_gift") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "acceptGiftNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: "Accept gift",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Gift accepted by {item?.addedBy?.userType ? item?.addedBy?.userType : null}
                  <strong> {item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "edited") {
        let wpSend = false;
        let wpSendStatus = false;
        // for(let row of whatsappNotificationLogs){
        //   if(row.type==='acceptGiftNotification'){
        //     wpSend = true;
        //     if(row.sendStatus)wpSendStatus = true;
        //   }
        // }
        items.push({
          title: "Edit Order",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Edit order by {item?.addedBy?.userType ? item?.addedBy?.userType : null}
                  <strong> {item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "resend_to_recipient") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "resendAcceptGiftNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: "Resend to recipient",
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Resend to recipient order by {item?.addedBy?.userType ? item?.addedBy?.userType : null}
                  <strong> {item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">Notification Sent</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
    }

  if (items.length === 1) items.push({ description: "Awaiting for send to customer." });

  return (
    <div className="px-9 py-5 border-gray-250 border-b w-full">
      <h2 className="text-base font-semibold ">Tracking History </h2>
      <Steps progressDot current={25} direction="vertical" items={items} />
    </div>
  );
};

export default TrackingHistory;
